<template>
  <block component-name="block-carousel-splitview" ref="tpl_root" :px="false">
    <template v-slot:default="blockData">
      <client-only v-if="isLaptop && useLandscape">
        <carousel-splitview-landscape
          :items="blockData.data.items"
          :sizes="{
            base: 600,
            phablet: 1020,
            tablet: 636,
            laptop: 756,
            desktop: 960,
            extdesktop: 1280,
          }"
          :force-lazy-loading="blockData?.loading === 'lazy'"
          class="w-full"
        />
      </client-only>

      <carousel-splitview-portrait
        v-else
        :items="blockData.data.items"
        :sizes="{
          base: 600,
          phablet: 1020,
          tablet: 1272,
          laptop: 1512,
          desktop: 1920,
          extdesktop: 2560,
        }"
        :force-lazy-loading="blockData?.loading === 'lazy'"
        class="w-full"
      />
    </template>
  </block>
</template>

<script setup>
const isLandscape = useMediaQuery("(orientation: landscape)");
const isLaptop = useMediaQuery("(min-width: 1272px)");
const useLandscape = computed(() => isLandscape.value && process.client);
</script>
